var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 8.66687C4.35356 8.66687 4.69265 8.80732 4.94266 9.05733C5.19267 9.30734 5.33312 9.64643 5.33312 10C5.33312 10.3536 5.19267 10.6926 4.94266 10.9427C4.69265 11.1927 4.35356 11.3331 3.99999 11.3331C3.64643 11.3331 3.30734 11.1927 3.05733 10.9427C2.80732 10.6926 2.66687 10.3536 2.66687 10C2.66687 9.64643 2.80732 9.30734 3.05733 9.05733C3.30734 8.80732 3.64643 8.66687 3.99999 8.66687ZM9.99999 8.66687C10.3536 8.66687 10.6926 8.80732 10.9427 9.05733C11.1927 9.30734 11.3331 9.64643 11.3331 10C11.3331 10.3536 11.1927 10.6926 10.9427 10.9427C10.6926 11.1927 10.3536 11.3331 9.99999 11.3331C9.64643 11.3331 9.30734 11.1927 9.05733 10.9427C8.80732 10.6926 8.66687 10.3536 8.66687 10C8.66687 9.64643 8.80732 9.30734 9.05733 9.05733C9.30734 8.80732 9.64643 8.66687 9.99999 8.66687ZM16 8.66687C16.3536 8.66687 16.6926 8.80732 16.9427 9.05733C17.1927 9.30734 17.3331 9.64643 17.3331 10C17.3331 10.3536 17.1927 10.6926 16.9427 10.9427C16.6926 11.1927 16.3536 11.3331 16 11.3331C15.6464 11.3331 15.3073 11.1927 15.0573 10.9427C14.8073 10.6926 14.6669 10.3536 14.6669 10C14.6669 9.64643 14.8073 9.30734 15.0573 9.05733C15.3073 8.80732 15.6464 8.66687 16 8.66687Z",
    fill: "#9099BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.0c9f3577132e63d57710e6fe9015f9c4.svg";
export { ForwardRef as ReactComponent };